import { Brand, Market } from '@oneaudi/avp-models';
import { ApiClient, Stage } from '@oneaudi/avp-hck-dga-customerui-commons';
import { DealerData, DisclaimerTexts } from '../constants/Interfaces';

export class CupraApiClient extends ApiClient {
  constructor(stage: Stage) {
    super(stage, Brand.SEAT);
  }

  public async getDisclaimerTexts(market: Market): Promise<DisclaimerTexts> {
    return this.doApiCall<void, DisclaimerTexts>(
      'GET',
      `${this.endpoint}/v1/intern/brands/cupra/markets/${market}/texts/disclaimer`,
    );
  }

  public async getDealerInformation(market: Market, kvpsId: string): Promise<DealerData> {
    return this.doApiCall<void, DealerData>(
      'GET',
      `${this.endpoint}/v1/intern/brands/cupra/markets/${market}/dealers/${kvpsId}`,
    );
  }
}
